export default {
  // LAYOUT
  SET_APP_HEIGHT(state, payload) {
    state.layouts.innerHeight = window.innerHeight;
    state.layouts.appBodyPosition = payload.appBodyPosition;
    state.layouts.appHeaderHeight = payload.appHeaderHeight;
    state.layouts.footerHeight = payload.footerHeight;
  },
  SET_SHOW_DETAIL(state, payload) {
    state.showDetail = payload;
  },

  // NAVIGATION
  SET_NAVIGATION_LIST(state, payload) {
    state.navigations.list = payload;
  },
  SET_NAVIGATION_ACTIVE(state, payload) {
    state.navigations.active = payload;
  },

  SET_NAVIGATION_ACTION(state, payload) {
    state.navigations.action = payload;
  },

  SET_REFETCH_BADGE(state, payload) {
    state.navigations.refetchBadge = payload
  },

  // CREATE
  TOGGLE_CREATE(state, payload) {
    state.create.isActive = payload;
  },

  SET_CREATE_TITLE(state, payload) {
    state.create.title = payload;
  },

  //header
  SET_HEADER_TITLE(state, payload) {
    state.header.title = payload;
  },
  SET_HEADER_SUBTITLE(state, payload) {
    state.header.subtitle = payload;
  },

  // EDIT
  TOGGLE_EDIT(state, payload) {
    state.edit.isActive = payload;
  },
  SET_EDIT_TITLE(state, payload) {
    state.edit.title = payload;
  },

  // SEARCH
  TOGGLE_SEARCH(state, payload) {
    state.search.onSearch = payload;
  },
  SET_QUERY_SEARCH(state, payload) {
    state.search.query = payload;
  },

  // FILTER
  TOGGLE_FILTER(state, payload) {
    state.filter.isActive = payload;
  },
  SET_FILTER_FORMS(state, payload) {
    state.filter.forms = payload;
  },
  SET_FILTER_OBJECT(state, payload) {
    state.filter.selected = payload;
  },
  SET_FILTER_TYPE(state, payload) {
    state.filter.input.type = payload;
  },
  SET_FILTER_QUERY(state, payload) {
    state.filter.input.query = payload;
  },
  PUSH_FILTER_LIST(state, payload) {
    const filters = state.filter.list.filter(
      (filter) => filter.type.value !== payload.type.value
    );
    state.filter.list = [...filters, payload];
  },
  REMOVE_FILTER(state, payload) {
    state.filter.list.splice(payload, 1);
  },
  EMPTY_FILTER_LIST(state) {
    state.filter.list = []
  },
  SET_PROFILE_AVATAR(state, payload) {
    state.profile.avatar = payload;
  },
  RELOAD_NOTIFICATION_DATA(state, payload) {
    state.notification.reloadData = payload
  }
};
